import React from 'react'

export const Separation = ({ height }) => {
  return <div style={{ height }} />;
};
